<template>
    <share-outfit-modal
        v-if="lastSuccessCartId > 0"
        title="Thank you for your purchase!"
        type="cart"
        :id="lastSuccessCartId"
        @close="closed"
    />
</template>


<script>
    import {mapGetters} from "vuex";

    import ShareOutfitModal from "../outfit/share-outfit-modal.vue";

    export default {
        components: {
            ShareOutfitModal
        },
        computed: {
            ...mapGetters({
                lastSuccessCartId: 'cart/getLastSuccessCartId'
            }),
        },
        methods: {
            closed() {
                this.$store.commit('cart/resetLastSuccessCartId');
            },
        },
    }
</script>